import type { ReactNode } from "react";

import type { NoteDetail } from "@/core/types";

import { getNoteBadgesContent } from "../../NoteBadges";
import { getNoteMetaContent } from "../../NoteMetaData";

type NoteStatusRowProps = {
  children?: ReactNode;
  note: NoteDetail;
};

export function NoteStatusRow({ children, note }: NoteStatusRowProps) {
  const badges = getNoteBadgesContent({ badgeSize: "md", note });
  const meta = getNoteMetaContent({ note, showSignature: false });
  const hasList = !!badges || !!meta;

  return (
    <div className="tw:flex tw:flex-col tw:gap-4 tw:border-t tw:border-stroke-quaternary tw:pt-4 tw:empty:hidden">
      {hasList && (
        <ul className="tw:flex tw:items-start tw:justify-start tw:gap-2 tw:lg:flex-row">
          {badges}
          {meta}
        </ul>
      )}

      {children}
    </div>
  );
}
